var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/** Drops empty measure blocks and coerces numeric strings to numbers. */
var cleanMeasures = function (measures) {
    if (!measures)
        return undefined;
    var cleaned = {
        height: measures.height ? Number(measures.height) : undefined,
        width: measures.width ? Number(measures.width) : undefined,
        thickness: measures.thickness ? Number(measures.thickness) : undefined,
        weight: measures.weight ? Number(measures.weight) : undefined,
    };
    return Object.values(cleaned).some(function (v) { return v !== undefined; })
        ? cleaned
        : undefined;
};
/**
 * Normalizes raw product form values into the payload accepted by the API:
 * trims empty measures, coerces extent values to numbers, drops incomplete
 * extents/relations and includes the price only when the price section is on.
 * Shared by the full-page product form and the in-panel create modal.
 *
 * @param data the raw react-hook-form values
 * @param options.title the title the product belongs to
 * @param options.showPrice whether the price section is enabled
 */
export var buildProductPayload = function (data, _a) {
    var _b, _c;
    var title = _a.title, showPrice = _a.showPrice;
    return (__assign(__assign({}, data), { title: title, unitMeasures: cleanMeasures(data.unitMeasures) || undefined, cartonMeasures: cleanMeasures(data.cartonMeasures) || undefined, palletMeasures: cleanMeasures(data.palletMeasures) || undefined, publishingDate: data.publishingDate, copyrightFrom: data.copyrightFrom, copyrightTo: data.copyrightTo, extents: ((_b = data.extents) === null || _b === void 0 ? void 0 : _b.filter(function (extent) { return extent.type && extent.value && extent.unit; }).map(function (extent) { return (__assign(__assign({}, extent), { value: Number(extent.value) })); })) || [], price: data.price && showPrice ? data.price : undefined, publishingStatus: data.publishingStatus || undefined, ownerId: data.ownerId || undefined, publicTime: data.publicTime || undefined, productsRelations: ((_c = data.productsRelations) === null || _c === void 0 ? void 0 : _c.filter(function (relation) { return relation.relationType && relation.relatedProductId; }).map(function (relation) { return ({
            id: relation.id,
            relationType: relation.relationType,
            relatedProductId: relation.relatedProductId,
        }); })) || [] }));
};
